import React from 'react';
import classNames from 'classnames';
import { FaCheck } from 'react-icons/fa';

import { BUILDING_WIZARD_STEPS } from './building-wizard.types';

interface BuildingWizardStepperProps {
  currentStep: number;
}

/**
 * Stepper for the in-tenant "Create building" wizard. Visually identical to the portfolio
 * onboarding stepper but driven by <c>BUILDING_WIZARD_STEPS</c> so the two flows can evolve
 * their step lists independently.
 */
export function BuildingWizardStepper({ currentStep }: BuildingWizardStepperProps) {
  return (
    <div className="w-full max-w-3xl mx-auto mb-2">
      <div className="flex items-start w-full">
        {BUILDING_WIZARD_STEPS.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;
          const isLast = index === BUILDING_WIZARD_STEPS.length - 1;

          return (
            <React.Fragment key={step.key}>
              <div className="flex flex-col items-center flex-1">
                <div
                  className={classNames(
                    'w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all',
                    isCompleted && 'bg-brand-primary border-brand-primary',
                    isCurrent && 'border-brand-primary bg-transparent',
                    !isCompleted && !isCurrent && 'border-white/20 bg-transparent',
                  )}
                >
                  {isCompleted ? (
                    <FaCheck className="text-black text-sm" />
                  ) : (
                    <span
                      className={classNames(
                        'text-sm font-semibold',
                        isCurrent ? 'text-brand-primary' : 'text-white/40',
                      )}
                    >
                      {stepNumber}
                    </span>
                  )}
                </div>
                <div className="mt-2 text-center">
                  <div
                    className={classNames(
                      'text-xs font-semibold tracking-wider',
                      isCurrent ? 'text-brand-primary' : isCompleted ? 'text-white' : 'text-white/40',
                    )}
                  >
                    {step.label}
                  </div>
                </div>
              </div>

              {!isLast && (
                <div className="flex-1 flex items-center mt-5">
                  <div
                    className={classNames(
                      'h-px w-full transition-all',
                      isCompleted ? 'bg-brand-primary' : 'bg-white/20',
                    )}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <div className="text-center mt-4 text-white/50 text-sm">
        Steg {currentStep + 1} av {BUILDING_WIZARD_STEPS.length}
      </div>
    </div>
  );
}
